import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LocationPickerComponent, SheetComponent } from '../../../../shared/ui';
import { ProductFilter } from '../../../shared';

@Component({
    selector: 'products-filter-sheet',
    template: require('./products-filter-sheet.component.pug')
})
export class ProductsFilterSheetComponent {
     @Input() fg: FormGroup;
     @Output() filterChanged = new EventEmitter<ProductFilter>();

    @ViewChild(SheetComponent) sheet;
    @ViewChild(LocationPickerComponent) locationPickerComponent;

    inventoryOptions = [];

    private _inStock: boolean;
    private _outStock: boolean;

    constructor() {
         this.setInventoryOptions(0, 0);
    }

    locationPickerReady() {
        this.onApplyClicked(null);
    }

    toggle() {
        this.sheet.toggle();
    }

    onStockOptionSelected(option: string) {
        this._inStock = option.indexOf('In') === 0;
        this._outStock = option.indexOf('Out')  === 0;
    }

    onApplyClicked(e: MouseEvent) {
        if (e) {
            e.preventDefault();
        }

        let form = this.fg;

        if (form.valid) {
                let locationsPickerSelection = this.locationPickerComponent.getSelection();
                let filter = new ProductFilter (
                                                            form.value.filter,
                                                            locationsPickerSelection,
                                                            this._inStock,
                                                            this._outStock
                                                        );
                this.filterChanged.emit(filter);
        }

    }

    setInventoryOptions(inStock: number, outStock: number) {
           this.inventoryOptions =  [
                                        `In Stock(${ inStock || 0})`,
                                        `Out Stock(${ outStock || 0})`
                                    ];
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/ui/products-filter-sheet/products-filter-sheet.component.ts